import { Injectable } from '@angular/core';
import { ServicioAutenticacion } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private isCollapsed = false;
  private estadosVentanas: { [key: string]: boolean } = {};
  private colapsoManual = false;
  private roles: string[] = [];

  constructor(private authService: ServicioAutenticacion) {
    this.authService.estaAutenticado().subscribe((autenticado) => {
      if (autenticado) {
        this.actualizarRoles();
      }
    });
  }

  private actualizarRoles(): void {
    const roles = this.authService.obtenerRolesDesdeToken();
    this.roles = roles;
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    this.colapsoManual = this.isCollapsed;
    const contentContainer = document.querySelector(
      '.content-container'
    ) as HTMLElement;
    if (this.isCollapsed) {
      contentContainer.style.marginLeft = '0';
    } else {
      contentContainer.style.marginLeft = '';
    }
  }

  obtenerEstadoBarraLateral(): boolean {
    return this.isCollapsed;
  }

  obtenerEstadoDeVentana(nombreVentana: string): boolean {
    return !!this.estadosVentanas[nombreVentana];
  }

  cambiarEstadoDeVentana(nombreVentana: string, estado: boolean): void {
    this.estadosVentanas[nombreVentana] = estado;
  }

  establecerEstadoBarraLateral(estado: boolean) {
    if (!this.colapsoManual || estado) {
      this.isCollapsed = estado;
    }
  }

  hasRole(role: string): boolean {
    const roles = this.authService.obtenerRolesDesdeToken();
    return roles.includes(role);
  }

  resetearEstadoManual() {
    this.colapsoManual = false;
  }
}
